// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.output_settings_section__K-sp5 {
  font-family: "Lexend Variable", sans-serif;
  color: #284480;
  font-size: 15px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: 0.04em;
  display: flex;
  border-bottom: #284480 2px solid;
  flex-basis: 50%;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  border-radius: 10px 10px 0 0;
}

.output_settings_voltage__OyQpH {
  background-color: #f4f4f4;
  color: #284480;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  border-radius: 0 20px 20px 0;
}

.output_settings_amp-input__zNEib {
  border: #e2e5f4 1px solid;
  background-color: #f4f6fb;
  border-radius: 10px;
  width: 60px;
  height: 38px;
  cursor: text;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  -moz-appearance: textfield;
}

.output_settings_amp-input__zNEib::-webkit-outer-spin-button,
.output_settings_amp-input__zNEib::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.output_settings_header__0sNx8 {
  display: flex;
  margin-top: 20px;
}

.output_settings_active__nQ0a7 {
  background-color: #ecf0f8;
  color: #6a86c8;
  border-bottom: transparent 2px solid;
}

.output_settings_item__6d26l {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #494b50;
  font-size: 16px;
  font-weight: 500;
  padding: 0 100px;
  gap: 20px;
}

.output_settings_item__6d26l:first-of-type {
  padding-top: 30px;
}

.output_settings_item__6d26l:last-of-type {
  padding-top: 30px;
  padding-bottom: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/detail/modals/output_settings/index.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".section {\n  font-family: \"Lexend Variable\", sans-serif;\n  color: #284480;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 29px;\n  letter-spacing: 0.04em;\n  display: flex;\n  border-bottom: #284480 2px solid;\n  flex-basis: 50%;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n  cursor: pointer;\n  border-radius: 10px 10px 0 0;\n}\n\n.voltage {\n  background-color: #f4f4f4;\n  color: #284480;\n  font-size: 24px;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0 30px;\n  border-radius: 0 20px 20px 0;\n}\n\n.amp-input {\n  border: #e2e5f4 1px solid;\n  background-color: #f4f6fb;\n  border-radius: 10px;\n  width: 60px;\n  height: 38px;\n  cursor: text;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  -moz-appearance: textfield;\n}\n\n.amp-input::-webkit-outer-spin-button,\n.amp-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.header {\n  display: flex;\n  margin-top: 20px;\n}\n\n.active {\n  background-color: #ecf0f8;\n  color: #6a86c8;\n  border-bottom: transparent 2px solid;\n}\n\n.item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #494b50;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 0 100px;\n  gap: 20px;\n}\n\n.item:first-of-type {\n  padding-top: 30px;\n}\n\n.item:last-of-type {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `output_settings_section__K-sp5`,
	"voltage": `output_settings_voltage__OyQpH`,
	"amp-input": `output_settings_amp-input__zNEib`,
	"header": `output_settings_header__0sNx8`,
	"active": `output_settings_active__nQ0a7`,
	"item": `output_settings_item__6d26l`
};
export default ___CSS_LOADER_EXPORT___;
